<template>
  <div>
  <v-layout row justify-center>
  <v-flex xs8 class="pl-2 pr-2">
    <v-layout align-start justify-start row class="mb-4">
      <v-icon color="primary" style="font-size: 50px;">account_box</v-icon>
      <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">{{$translate('GENERAL')}}</h2>
    </v-layout>
    <v-divider class="mb-2"></v-divider>

    <v-spacer></v-spacer>
    <v-form>
      <v-text-field
        v-model="general_customerPreferences.Link"
        :label="$translate('ACCOUNT_LINK')"
        required
        value="2"
        disabled
      ></v-text-field>
      <v-text-field
        v-model="general_customerPreferences.AccountName"
        :label="$translate('ACCOUNT_NAME')"
        required
        value="2"
        disabled
      ></v-text-field>
      <v-text-field
        v-model="general_customerPreferences.State"
        :label="$translate('PAR_CON_STATUS')"
        required
        value="2"
        disabled
      ></v-text-field>
      <v-text-field
        v-model="general_customerPreferences.AccountDescription"
        :label="$translate('ACCOUNT_DESCRIPTION')"
        required
        value="2"
      ></v-text-field>
      <v-text-field
        v-model="general_customerPreferences.CompanyAddress"
        :label="$translate('ADDRESS')"
        required
        value="2"
      ></v-text-field>
      <v-text-field
        v-model="general_customerPreferences.CompanyName"
        :label="$translate('COMPANY_NAME')"
        required
        value="2"
      ></v-text-field>
      <v-text-field
        v-model="general_customerPreferences.CompanyEmail"
        :label="$translate('COMPANY_EMAIL')"
        required
        value="2"
      ></v-text-field>
      <v-select
        :label="$translate('ACCOUNT_MAIN_LOCATION')"
        v-model="general_customerPreferences.LocationId"
        :items="allLocations"
        item-text="Name"
        item-value="LocationId"
        class="mr-2 ml-2"
        persistent-hint
        required
      ></v-select>
      <v-text-field
        v-model="general_customerPreferences.AdministrationNr"
        :label="$translate('ACCOUNT_ADMIN_NUMBER_SALE')"
        required
        value="2"
      ></v-text-field>
      <v-text-field
        v-model="general_customerPreferences.AdministrationNrFee"
        :label="$translate('ACCOUNT_ADMIN_NUMBER_FEE')"
        required
        value="2"
      ></v-text-field>
      <v-text-field
      min="0"
      max="100"
      suffix="%"
      type="number"
      :label="$translate('ACCOUNT_SERVICE_PERCENTAGE')"
      v-model="general_customerPreferences.ServicePercentage"
      required
      />
      <v-text-field
        v-model="general_customerPreferences.MaxPrebooks"
        :label="$translate('ACCOUNT_MAX_PREBOOKS')"
        :value="general_customerPreferences.MaxPrebooks"
        type="number"
        :rules="numberRule"
        min="1"
        required
      ></v-text-field>
      <v-layout>
        <v-flex pr-2>
          <v-text-field
            min="0"
            max="100"
            suffix="%"
            type="number"
            :label="$translate('ACCOUNT_HIGH_VAT')"
            v-model="general_customerPreferences.Vat['High'].Percentage"
            required
          />
        </v-flex>
        <v-flex pl-2>
          <v-text-field
            min="0"
            max="100"
            suffix="%"
            type="number"
            :label="$translate('ACCOUNT_LOW_VAT')"
            v-model="general_customerPreferences.Vat['Low'].Percentage"
            required
          />
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout align-end justify-end row offset-xs0 offset-lg2 mb-3>
      <v-card-actions>
        <v-tooltip bottom>
          <v-btn
            round
            slot="activator"
            color="primary"
            :loading="disableButton"
            :disabled="disableButton"
            class="v-btn-5 dialogButton text-capitalize"
            @click="saveAccountGeneral"
          >{{$translate('SAVE')}}</v-btn>
          <span>{{$translate('SAVE')}}</span>
        </v-tooltip>
      </v-card-actions>
    </v-layout>
  </v-flex>
</v-layout>
  <v-layout row justify-center>
    <v-flex xs8 class="pl-2 pr-2">
      <v-layout align-start justify-start row class="mb-4">
        <v-icon color="primary" style="font-size: 50px;">build</v-icon>
        <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">{{$translate('ACCOUNT_SALES_&_FEES')}} {{selectedAccount.AccountDescription}}</h2>
      </v-layout>
      <v-divider class="mb-2"></v-divider>
      <v-spacer></v-spacer>
      <v-form>
        <v-select
          @change="accountIsChanged"
          :label="$translate('ACCOUNT_TITLE')"
          v-model="selectedAccount"
          return-object
          :items="allAccounts"
          item-text="AccountDescription"
          item-value="AccountId"
          class="mr-2 ml-2"
          persistent-hint
          required
        ></v-select>
        <v-text-field
          v-model="serverSettings.BookNumberSales"
          label="BookNumber Sales"
          type="number"
          min="0"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="serverSettings.BookNumberFees"
          :label="$translate('ACCOUNT_BOOKNUMBER_FEE')"
          type="number"
          min="0"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="serverSettings.DiaryNumberSales"
          :label="$translate('ACCOUNT_JOURNAL_NUMBER_SALES')"
          type="number"
          min="0"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="serverSettings.DiaryNumberFees"
          :label="$translate('ACCOUNT_JOURNAL_NUMBER_FEES')"
          type="number"
          min="0"
          required
          value="2"
        ></v-text-field>
<!--        <v-text-field-->
<!--          v-model="serverSettings.HourForCalc"-->
<!--          label="Generation Hour"-->
<!--          type="number"-->
<!--          min="0"-->
<!--          required-->
<!--          value="2"-->
<!--        ></v-text-field>-->
        <v-text-field
          v-model="serverSettings.HighPercVat"
          label="TDF Fee %"
          type="number"
          min="0"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="serverSettings.NodeName"
          :label="$translate('ACCOUNT_NAME_OF_FILE')"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="serverSettings.MonthlyFeeDay"
          :label="$translate('ACCOUNT_MONTHLY_FEE_GENERATION_DAY')"
          type="number"
          min="0"
          required
          value="2"
        ></v-text-field>
        <v-flex>
          <v-menu
            ref="menu3"
            :close-on-content-click="true"
            v-model="menu3"
            :nudge-right="40"
            :return-value.sync="chosenDate"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="computedDateFormattedDate"
              :label="$translate('ACCOUNT_GENERATION_DAY')"
              hide-details
              append-icon="event"
              readonly
              ref="eventForm"
            ></v-text-field>
            <v-date-picker
              first-day-of-week="1"
              color="primary"
              v-model="chosenDate"
              @input="$refs.menu3.save(chosenDate)"
              no-title
            />
          </v-menu>
        </v-flex>
        <v-layout>
          <v-flex pr-2>
            <v-menu
              ref="menu1"
              :close-on-content-click="true"
              v-model="menu1"
              :nudge-right="40"
              :return-value.sync="chosenStartDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="computedDateFormattedStartDate"
                :label="$translate('STARTDATE')"
                hide-details
                append-icon="event"
                readonly
                ref="eventForm"
              ></v-text-field>
              <v-date-picker
                first-day-of-week="1"
                color="primary"
                v-model="chosenStartDate"
                @input="$refs.menu1.save(chosenStartDate)"
                no-title
              />
            </v-menu>
          </v-flex>
          <v-flex pl-2>
            <v-menu
              ref="menu2"
              :close-on-content-click="true"
              v-model="menu2"
              :nudge-right="40"
              :return-value.sync="chosenEndDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="computedDateFormattedEndDate"
                :label="$translate('ENDDATE')"
                hide-details
                append-icon="event"
                readonly
                ref="eventForm"
              ></v-text-field>
              <v-date-picker
                first-day-of-week="1"
                color="primary"
                v-model="chosenEndDate"
                @input="$refs.menu2.save(chosenEndDate)"
                no-title
              />
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-layout mt-2 align-end justify-end row offset-xs0 offset-lg2 mb-3>
        <v-card-actions>
          <v-tooltip bottom>
            <v-btn
              round
              slot="activator"
              color="primary"
              class="v-btn-5 dialogButton text-capitalize"
              @click="setSalesFeesPref"
            >{{$translate('SAVE')}}</v-btn>
            <span>{{$translate('SAVE')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-layout>
      <v-layout align-start justify-start row>
        <v-flex xs12>
          <v-card class="pa-1">
            <h3 class="textClass">{{$translate('ACCOUNT_SAVE_SALES_FEE')}}</h3>
            <h4 class="textClass">{{$translate('ACCOUNT_BOTH_BUTTONS')}}: <i>{{selectedAccount.AccountDescription}}</i></h4>
            <v-tooltip bottom>
              <v-btn
                round
                slot="activator"
                color="primary"
                class="v-btn-5 ml-2 dialogButton text-capitalize"
                @click="generateSalesFees()"
              >{{$translate('ACCOUNT_GENERATE_SALES_FEES')}}</v-btn>
              <span>{{$translate('SAVE')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                round
                slot="activator"
                color="primary"
                class="v-btn-5 ml-2 dialogButton text-capitalize"
                @click="generateMonthlyFees()"
              >{{$translate('ACCOUNT_GENERATE_MONTHLY_FEES')}}</v-btn>
              <span>{{$translate('SAVE')}}</span>
            </v-tooltip>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import _ from "lodash";
import { mapGetters } from "vuex";
import { store } from "../../store.js";
import BaseObject from "@/objects/BaseObject";

export default {
  name: "Account-General",
  computed: {
    ...mapGetters({
      currentAccountId: "getCurrentAccountId"
    }),
    computedDateFormattedStartDate() {
      return this.formatDate(this.chosenStartDate);
    },
    computedDateFormattedEndDate() {
      return this.formatDate(this.chosenEndDate);
    },
    computedDateFormattedDate() {
      return this.formatDate(this.chosenDate);
    },
  },
  data() {
    return {
      // date picker
      menu1: '',
      menu2: '',
      menu3: '',
      chosenStartDate: '',
      chosenEndDate: '',
      chosenDate: '',
      selectedAccount: '',
      allAccounts: [],
      allLocations: [],
      serverSettings: {},
      numberRule: [v => (v > 0 && v < 10) || "1-9 allowed"],
      disableButton: false,
      general_customerPreferences: {}
    };
  },
  created() {
  },
  mounted() {
    this.general_customerPreferences = store.getters.getAccountInfo;
    this.general_customerPreferences.Vat = store.getters.getAccountVat;
    this.getLocations();
    this.getAccounts();
    if (!store.getters.getAccountVat.hasOwnProperty("None")) {
      this.general_customerPreferences.Vat = {
        'None': {
          Name: 'Zero',
          Percentage: 0
        },
        'Low': {
          Name: 'Low',
          Percentage: 0
        },
        'High': {
          Name: 'High',
          Percentage: 0
        }
      };
    } else {
      this.general_customerPreferences.Vat = store.getters.getAccountVat;
    }
  },
  beforeDestroy() {},

  methods: {
    generateSalesFees(){
      let payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for 'generateSalesFees' on - Account_General.vue - was successful",
            response
          );
          window.EventBus.fire(
            "activateSnackBar",
            "Generate sales fees was successful!"
          );
        },
        error => {
          console.log(
            "The call for 'generateSalesFees' on - Account_General.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GSF_001');
        },
        "generateSalesFees",
        this.selectedAccount.AccountId,
        payload,
        600000,
        false
      );
    },
    generateMonthlyFees(){
      let payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for 'generateMonthlyFees' on - Account_General.vue - was successful",
            response
          );
          window.EventBus.fire(
            "activateSnackBar",
            "Generate Monthly Fees was successful!"
          );
        },
        error => {
          console.log(
            "The call for 'generateMonthlyFees' was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GMF_001');
        },
        "generateMonthlyFees",
        this.selectedAccount.AccountId,
        payload,
        600000,
        false
      );
    },
    getAccounts() {
      let payload = {
        FunctionId : "AccountFunctionLibrary::getAccounts"
    };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call 'getAccounts' on - Account_General.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty('Accounts')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GA_001');
            return;
          }
          this.allAccounts = BaseObject._createArrayWithObjects(response.data.Accounts);
          this.selectedAccount = this.allAccounts[0];
          this.getSalesFeesPref();

        },
        error => {
          console.log(
            "The generic call 'getAccounts' on - Account_Genera.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GA_001');
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId,
        payload,
        600000,
        false
      );
    },
    getLocations() {
      // This function is used to retrieve the locations to select a main location for the account
      let payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for 'getLocations' to pick a main location for the account on - Account_General.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty('Locations')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
            return;
          }
          for (const [key, value] of Object.entries(response.data.Locations)) {
            this.allLocations.push(value);
          }

        },
        error => {
          console.log(
            "The call for 'getLocations' to pick a main location for the account on - Account_General.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
        },
        "getLocations",
        this.$store.getters.getCurrentAccountId,
        payload,
        600000,
        false
      );
    },
    getSalesFeesPref() {
      // Storing the server sales settings
      let payload = {};

      dssRequest.doRequest(
        response => {
          console.log(
            "The call for 'getSalesFeesPref' on - Account_General.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty('StartDate')) {
            window.EventBus.fire('triggerGenericErrorDialog', 'W_GSFP_001');
            return;
          }
          if (!response.data.hasOwnProperty('EndDate')) {
            window.EventBus.fire('triggerGenericErrorDialog', 'W_GSFP_002');
            return;
          }
          if (!response.data.hasOwnProperty('GenerationDate')) {
            window.EventBus.fire('triggerGenericErrorDialog', 'W_GSFP_003');
            return;
          }
          this.serverSettings = response.data;
          this.chosenStartDate = this.serverSettings.StartDate.split("-").reverse().join("-");
          this.chosenEndDate = this.serverSettings.EndDate.split("-").reverse().join("-");
          this.chosenDate = this.serverSettings.GenerationDate.split("-").reverse().join("-");
        },
        error => {
          console.log(
            "The call for 'getSalesFeesPref' on - Account_General.vue - was not successful",
            error
          );
          window.EventBus.fire('triggerGenericErrorDialog', 'W_GSFP_004');
        },
        "getSalesFeesPref",
        this.selectedAccount.AccountId,
        payload,
        600000,
        false
      );
    },
    setSalesFeesPref() {
    // Storing the server sales settings
      this.serverSettings.StartDate = this.computedDateFormattedStartDate;
      this.serverSettings.EndDate = this.computedDateFormattedEndDate;
      this.serverSettings.MonthlyFeeDay = Number(this.serverSettings.MonthlyFeeDay);
      this.serverSettings.GenerationDate = this.computedDateFormattedDate;
      this.serverSettings.HighPercVat = Number(this.serverSettings.HighPercVat);
      this.serverSettings.BookNumberFees = Number(this.serverSettings.BookNumberFees);
      this.serverSettings.BookNumberSales = Number(this.serverSettings.BookNumberSales);
      this.serverSettings.DiaryNumberFees = Number(this.serverSettings.DiaryNumberFees);
      this.serverSettings.DiaryNumberSales = Number(this.serverSettings.DiaryNumberSales);

      dssRequest.doRequest(
        response => {
          console.log(
            "The call for 'setSalesFeesPref' on - Account_General.vue - was successful",
            response
          );
          window.EventBus.fire(
            "activateSnackBar",
            "Server settings saved"
          );
        },
        error => {
          console.log(
            "The call for 'setSalesFeesPref' on - Account_General.vue - was not successful",
            error
          );
          window.EventBus.fire('triggerGenericErrorDialog', 'W_SSFP_001');
        },
        "setSalesFeesPref",
        this.selectedAccount.AccountId,
        this.serverSettings,
        600000,
        false
      );
    },
    saveAccountGeneral() {
      // This used to be the generic call updateAccount
      const dataForPayload = this.general_customerPreferences;
      const json = "";
      const payload = {
        FunctionId: "AccountFunctionLibrary::updateAccount",
        Action: "UPDATE",
        TableName: "config.Account",
        WhereClause: "AccountId = '" + this.currentAccountId + "'",
        AccountDescription: dataForPayload.AccountDescription,
        AccountName: dataForPayload.AccountName,
        CompanyAddress: dataForPayload.CompanyAddress,
        CompanyEmail: dataForPayload.CompanyEmail,
        AdministrationNr: dataForPayload.AdministrationNr,
        AdministrationNrFee: dataForPayload.AdministrationNrFee,
        CompanyName: dataForPayload.CompanyName,
        CompanyWebsite: dataForPayload.CompanyWebsite,
        CreationDate: dataForPayload.CreationDate,
        ExpirationDate: dataForPayload.ExpirationDate,
        LocationId: dataForPayload.LocationId,
        Link: dataForPayload.Link,
        MemberTagId: dataForPayload.MemberTagId,
        State: dataForPayload.State,
        MaxPrebooks: dataForPayload.MaxPrebooks,
        Vat: dataForPayload.Vat,
        ServicePercentage: dataForPayload.ServicePercentage
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call for 'updateAccount' on - Account_General.vue - was successful",
            response
          );
          window.EventBus.fire(
            "activateSnackBar",
            this.$translate("ACCOUNT_SAVED_OK")
          );
        },
        error => {
          console.log(
            "The generic call for 'updateAccount' on - Account_General.vue - was not successful",
            error
          );
          window.EventBus.fire('triggerGenericErrorDialog', 'W_UA_001');
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload,
        600000,
        false
      );
    },
    accountIsChanged() {
      // user selected a new account
      this.getSalesFeesPref();
    },
    formatDate(date) {

      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  }
};
</script>

<style lang="scss" scoped>
  .textClass {
    text-align: left;
  }
</style>
